export default __webpack_public_path__ + "static/media/avatar4.54d5c1de.png";